export const locale = {
    lang: 'en',
    data: {
        'App': {
            'NAME': 'Qualisys',
            'ADD': 'Add',
            'NEXT': 'Next',
            'CLEAR': 'Clear',
            'EDIT': 'Edit',
            'DELETE': 'Delete',
            'SAVE': 'Save',
            'CANCEL': 'Cancel',
            'MSG-DELETE': 'Are you sure you want to delete this item?',
            'ACTION': 'Action',
            'EMPTY-MSG': 'No record',
            'CONFIRM': 'Confirm',
            'TITLE_WITHOUT_SAVING': 'Unsaved changes',
            'QUIT': 'Quit without saving',
            'DOWNLOAD': 'Download',
            'INVALID-SIZE-MSG': 'the file size must not exceed',
            'SUMMARY_ERROR': 'Error',
            'SUMMARY_WARNING': 'Warning!',
            'SUMMARY_SUCCESS': 'Success',
            'MSG_ERROR_CREATE': 'Creation error',
            'MSG_ERROR_LOAD': 'Loading error',
            'MSG_ERROR_UPDATE': 'Update error',
            'MSG_ERROR_DELETE': 'Deletion error',
            'MSG_FORBIDDEN': 'You are not allowed to perform this action.',
            'MSG_ERROR_DELETE_FK': 'This element cannot be deleted because it is used by other elements.',
            'PrimeNGConfig': {
                'monthNames': ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                'dayNamesMin': ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
                "dateIs": "Date is",
                "dateIsNot": "Date is not",
                "dateBefore": "Date before",
                "dateAfter": "Date after",
                "clear": "Clear",
                "apply": "Apply",
                "addRule": "Add Rule",
                "removeRule": "Remove Rule",
            },
            'SEARCH': 'Search...',
            'NEW': 'New',
            'DUPLICATE': 'Duplicate',
            'COPY': 'Copy',
            'OF': 'of',
            'ADD_CREATE': 'Add and create',
            'NONE': 'None',
            'INVALID_EMAIL': 'E-mail address is not valid!',
            'YES': 'Yes',
            'NO': 'No',
            'PRINT': 'Print',
            'monthNamesMin': ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
            'CHANGER': 'Change',
            'ANS': 'years',
            'AN': 'year',
            'MONTHS': 'months',
            'MONTH': 'month',
            'JOURS': 'day(s)',
            'JOUR': 'day',
            'EXPORT': 'Export Excel',
            'IMPORT': 'Import Excel',
            'IMPORT_TITLE': 'Import done',
            'IMPORT_MSG': 'Import was successfully completed!',
            'SIMPLE_DIALOG': {
                'NAME': 'Name',
                'DESCRIPTION': 'Description'
            },
            'MSG_UNSAVED_FORM': 'Are you sure you want to exit without saving your changes?',
            'POWERED_BY': 'Powered by',
            'ENTREPRISE': 'Sama Consulting',
            'MSG_ERROR_CONFLICT': 'Record already created!',
            'MSG_ERROR_INVALID_ROW_VERSION': 'The data has been modified by another user. You need to refresh the page and redo your modifications.',
            'NO_VALUE_FOUND': 'No value found',
            'PUBLISH': 'Publish',
            'MSG_MAX_FILE_SIZE': 'The file is too large. Allowed maximum size is {{maxFileSize}} MB',
            'MSG_REQUIRED_FORM': 'Please fill in the required fields',
            'NB': 'Please note: ',
            'SELECTIONNEZ_FICHIER': 'Select a file',
            'OK': 'Ok',
            'INFO': 'Info',
            'ATTENTION': 'Attention',
           	'NoInternetConnection': 'No internet connection',
            'InternetReconnected': 'Internet connection restored',

	
        }

    }
};